import React, { useState, useEffect } from 'react';
import '../Settings/Settings.css';
import InstaTopbar from '../InstaTopbar/InstaTopbar';
import useBlockCheck from '../../hooks/useBlockCheck'; // Import the hook

const Settings = () => {
  useBlockCheck('user'); // 🔥 Prevents blocked users from accessing this page
  // State to track the toggle values for notifications and dark mode
  const [enableNotifications, setEnableNotifications] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  // Toggle function for notifications
  const handleNotificationToggle = () => {
    setEnableNotifications(!enableNotifications);
    // Save the notification preference to localStorage
    localStorage.setItem('enableNotifications', !enableNotifications);
  };

  // Toggle function for dark mode
  const handleDarkModeToggle = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    // If you want to apply dark mode style, toggle the class on the body
    document.body.classList.toggle('dark-mode', newDarkMode);
    // Save the dark mode preference to localStorage
    localStorage.setItem('darkMode', newDarkMode);
  };

  // When the component mounts, check localStorage for saved settings
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    const savedNotifications = localStorage.getItem('enableNotifications') === 'true';
    
    setDarkMode(savedDarkMode);
    setEnableNotifications(savedNotifications);

    // Apply dark mode if saved in localStorage
    if (savedDarkMode) {
      document.body.classList.add('dark-mode');
    }
  }, []);

  return (
    <div>
      <InstaTopbar />
      <div className="page-container">
        <h1>Settings</h1>
        <p>Customize your dashboard settings and preferences.</p>

        <div className="settings-container">
          {/* Enable Notifications */}
          <div>
            <label>
              <input
                type="checkbox"
                checked={enableNotifications}
                onChange={handleNotificationToggle}
              />
            Enable Notifications
            </label>
          </div>

          {/* Dark Mode */}
          <div>
            <label>
              <input
                type="checkbox"
                checked={darkMode}
                onChange={handleDarkModeToggle}
              />
            Dark Mode
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
